var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d9bf0;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.17,26.98c8.81,0,13.62-7.3,13.62-13.62,0-.21,0-.41-.01-.62.93-.68,1.75-1.52,2.39-2.48-.86.38-1.78.64-2.75.75.99-.59,1.75-1.53,2.11-2.65-.93.55-1.95.95-3.04,1.16-1.03-1.09-2.56-1.7-4.22-1.46-2.32.34-4.07,2.41-4.06,4.75,0,.37.04.73.12,1.07-3.98-.2-7.51-2.11-9.87-5-.41.71-.65,1.53-.65,2.41,0,1.66.85,3.13,2.13,3.98-.79-.02-1.52-.24-2.17-.6h0c-.03,2.35,1.63,4.31,3.84,4.75-.4.11-.83.17-1.26.17-.31,0-.61-.03-.9-.09.61,1.9,2.38,3.29,4.47,3.33-1.64,1.28-3.7,2.05-5.95,2.05-.39,0-.77-.02-1.14-.07,2.12,1.36,4.63,2.15,7.34,2.15h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fe68fff559bae8687587697b70ef8379.svg";
export { ForwardRef as ReactComponent };